import qs from 'qs';

import axios from 'axios';

type CsvQueryParams = Record<string, unknown>;

export async function fetchCsvAsBlob(
  url: string,
  params?: CsvQueryParams,
): Promise<Blob> {
  const response = await axios.get<Blob>(url, {
    responseType: 'blob',
    params,
    paramsSerializer: (queryParams) => qs.stringify(queryParams),
  });

  return response.data;
}

export async function fetchPaginatedCsvAsBlob(
  url: string,
  params: CsvQueryParams,
  limit = 100,
  maxLimit = 1_000_000,
): Promise<Blob> {
  let offset = 0;
  const blobs: Blob[] = [];

  while (offset <= maxLimit) {
    // Requests are sequential because each response determines whether another page exists.
    // eslint-disable-next-line no-await-in-loop
    const blob = await fetchCsvAsBlob(url, {
      ...params,
      headerShown: offset === 0,
      limit,
      offset,
    });

    if (blob.size === 0) {
      break;
    }

    blobs.push(blob);
    offset += limit;
  }

  return new Blob(blobs, { type: 'text/csv' });
}
